module.exports = __webpack_public_path__ + "app_76x76.c7e37c5ac837afd6312686e0ac911e0e.png";